import React, { useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { toast } from "sonner";
import { Repeat } from "lucide-react";
import { useOperator } from "@/components/mobile/operators";

const Line = ({ label, value, testId, strong }) => <div className={`flex justify-between gap-4 ${strong ? "font-semibold border-t border-border pt-1" : ""}`}><span>{label}</span><span data-testid={testId}>{value}</span></div>;

export const ImPromoChange = ({ plans, terms }) => {
  const op = useOperator();
  const [form, setForm] = useState({ phone_number: "", iccid: "", piano: "", note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));
  const plan = plans.find((p) => p.name === form.piano);
  const fee = terms.promo_change_fee ?? 5, pct = terms.agio_percent ?? 0;
  const agio = plan ? Math.round(plan.price * pct) / 100 : 0;
  const total = plan ? Math.round((fee + plan.price - agio) * 100) / 100 : null;
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/italiamobile/requests", { request_type: "cambio_promo", operator: op.key, ...form });
      toast.success(`Cambio promo inviato (ID ${data.id.slice(-6)}): addebitati ${euro(total)} dal Plafond servizi.`);
      setForm({ phone_number: "", iccid: "", piano: "", note: "" });
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invio non riuscito"); }
    finally { setBusy(false); }
  };
  return (
    <Card className="p-6 glow-border space-y-4" data-testid="im-promo-card">
      <p className="text-sm text-muted-foreground">Passa il cliente a un profilo superiore o inferiore. Il nuovo canone riparte dal giorno del cambio.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label>Numero {op.name} *</Label><Input type="tel" className="mt-1.5" data-testid="im-p-phone" value={form.phone_number} onChange={set("phone_number")} placeholder="+39 3xx…" /></div>
        <div><Label>ICCID (facoltativo)</Label><Input className="mt-1.5" data-testid="im-p-iccid" value={form.iccid} onChange={set("iccid")} placeholder="8939…" /></div>
      </div>
      <div><Label>Nuovo profilo *</Label>
        <Select value={form.piano} onValueChange={(v) => setForm((s) => ({ ...s, piano: v }))}>
          <SelectTrigger className="mt-1.5" data-testid="im-p-plan"><SelectValue placeholder="Scegli il nuovo profilo" /></SelectTrigger>
          <SelectContent>{plans.map((p) => <SelectItem key={p.id} value={p.name} data-testid={`im-p-plan-${p.id}`}>{p.name} — {euro(p.price)}/mese · {p.dati}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {plan && (
        <div className="rounded-lg border border-border p-4 space-y-1 text-sm" data-testid="im-promo-summary">
          <Line label="Costo cambio promo" value={euro(fee)} testId="im-promo-fee" />
          <Line label={`Canone ${plan.name} (riparte da oggi)`} value={euro(plan.price)} testId="im-promo-canone" />
          <Line label={`Tuo agio (${pct}%)`} value={`− ${euro(agio)}`} testId="im-promo-agio" />
          <Line label="Addebito sul Plafond servizi" value={euro(total)} testId="im-promo-total" strong />
          <p className="text-xs text-muted-foreground pt-1">Se la pratica viene annullata, l'importo ti viene rimborsato in automatico.</p>
        </div>
      )}
      <div><Label>Note</Label><Textarea className="mt-1.5" data-testid="im-p-note" value={form.note} onChange={set("note")} /></div>
      <Button onClick={submit} disabled={busy || !plan || !form.phone_number.trim()} className="gap-2" data-testid="im-submit-promo"><Repeat className="w-4 h-4" /> {busy ? "Invio…" : total != null ? `Conferma cambio promo · ${euro(total)}` : "Conferma cambio promo"}</Button>
    </Card>
  );
};
